var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "product-list-item card",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
          [
            _c(
              "div",
              { staticClass: "product-image-wrapper" },
              [
                _vm._t("item-image", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        )
                      }
                    },
                    [
                      _c("lazy-img", {
                        attrs: {
                          "picture-class": "product-image",
                          "image-url": _vm.item.images.all[0].urlMiddle,
                          alt: _vm.item.texts.name1,
                          title: _vm.item.texts.name1
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _vm._t("store-special", [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._t("item-details", [
              _c(
                "div",
                { staticClass: "product-info" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "product-name",
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        )
                      }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm._f("itemName")(_vm.item))
                      ),
                      _vm._l(_vm.item.groupedAttributes, function(attribute) {
                        return _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("translate")(
                                "Ceres::Template.itemGroupedAttribute",
                                attribute
                              )
                            )
                          )
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("before-prices"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "product-price",
                      class: {
                        "product-price--sale":
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.unitPrice.value
                      }
                    },
                    [
                      _vm.item.item.itemType === "set"
                        ? [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemSetPrice",
                                    { price: _vm.itemSetPrice }
                                  )
                                )
                            ),
                            _c("sup", [_vm._v("*")])
                          ]
                        : !!_vm.item.item &&
                          _vm.item.item.salableVariationCount > 1 &&
                          _vm.$ceres.isCheapestSorting
                        ? [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.categoryItemFromPrice",
                                    { price: _vm.itemPrice }
                                  )
                                )
                            ),
                            _c("sup", [_vm._v("*")])
                          ]
                        : [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm._f("specialOffer")(
                                    _vm.item.prices.default.unitPrice.formatted,
                                    _vm.item.prices,
                                    "unitPrice",
                                    "formatted"
                                  )
                                )
                            ),
                            _c("sup", [_vm._v("*")])
                          ],
                      _vm._v(" "),
                      _vm.item.prices.rrp &&
                      _vm.item.prices.rrp.price.value > 0 &&
                      _vm.item.prices.rrp.price.value >
                        _vm.item.prices.default.unitPrice.value
                        ? [
                            _vm.item.prices.specialOffer
                              ? _c(
                                  "span",
                                  { staticClass: "product-price--uvp" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.item.prices.default.unitPrice
                                            .formatted
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "product-price--uvp" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.item.prices.rrp.unitPrice
                                            .formatted
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("after-prices")
                ],
                2
              )
            ])
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }